/* File : src/App.js */
import React from 'react';
import AppRoutes from './routes';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import './App.css';

/**
 * Composant principal de l'application
 * Encapsule les routes dans les providers de contexte
 */
function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <div className="app">
          <AppRoutes />
        </div>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;